(() => {
  if (customElements.get('varia-aura-gallery')) return;
  class VariaAuraGallery extends HTMLElement {
    connectedCallback() {
      this.page = this.closest('product-page');
      if (!this.page) return;
      this.onVariant = event => {
        const variant = event.target.currentVariant;
        const colour = variant?.options?.[Number(this.dataset.colourIndex)];
        if (colour) this.select(colour);
      };
      this.page.addEventListener('VARIANT_CHANGE', this.onVariant, true);
      this.page.addEventListener('change', this.onChange = event => {
        const selected = event.target.closest('product-variants');
        if (!selected) return;
        const options = [...selected.querySelectorAll('[data-js-product-variant]')];
        const control = options[Number(this.dataset.colourIndex)]?.querySelector('select, input:checked');
        if (control) this.select(control.value);
      });
      const selected = this.page.querySelector('product-variants');
      if (selected?.currentVariant) this.onVariant({target: selected});
    }
    select(colour) {
      const figures = [...this.querySelectorAll('[data-aura-colour]')];
      const match = figures.find(figure => figure.dataset.auraColour === colour);
      if (!match) return;
      figures.forEach(figure => { figure.hidden = figure !== match; });
    }
    disconnectedCallback() {
      this.page?.removeEventListener('VARIANT_CHANGE', this.onVariant, true);
      this.page?.removeEventListener('change', this.onChange);
    }
  }
  customElements.define('varia-aura-gallery', VariaAuraGallery);
})();
